import { Navigate, Outlet } from "react-router-dom";
import { RoutePath } from "@/routes";
import { authService } from "@/services";

export default function GuestRoute() {
  if (authService.isAuthenticated()) {
    return <Navigate to={RoutePath.Home} replace />;
  }

  return <Outlet />;
}
